<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <h6 class="upper-text">Deseja realmente excluir a prescrição?</h6>
      </div>
      <div class="col-md-12"><ErrorsMessages :errors="errors" /></div>

      <div class="col-md-12 text-right">
        <v-btn
          :disabled="loading"
          @click="deleteGroupPrescriptionMedicine"
          class="btn-delete"
          ><i class="fas fa-trash mr-2 text-twenty"></i>
          {{ loading ? "CARREGANDO" : "EXCLUIR" }}</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../templates/Components/ErrorsMessages";

import api from "../../../services/api";

import toast from "../../../lib/ToastNotification";

export default {
  name: "Medicine",
  components: {
    ErrorsMessages,
  },
  props: {
    id: [String, Number],
  },
  data() {
    return {
      loading: false,
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    async retrieve() {},
    async deleteGroupPrescriptionMedicine() {
      try {
        this.loading = true;

        let { id } = this;

        let data = { id };

        const response = await api.delete(
          "/rest-home/group-prescription-medicine",
          {
            data,
          }
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("delete", "paginate");
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
